module.exports = __webpack_public_path__ + "media/images/icon_tab1_on_sp-860364b85a705ba2d504428b5fa79856.png";